module.exports = __webpack_public_path__ + "img/cuff_width.c79b54b2.png";